import React from "react"
import MUIGrid, { GridProps as MUIGridProps } from "@mui/material/Grid"

export type GridProps =
  | ({ new?: false } & MUIGridProps)
  | ({ new: true } & unknown)

export const Grid = React.forwardRef<HTMLDivElement, GridProps>((props, ref) =>
  props.new ? null : <MUIGrid {...props} ref={ref} />,
)

Grid.displayName = "Grid"

export default Grid
